import React$1 from 'react';

const Play = () => /*#__PURE__*/React$1.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "59",
  height: "59"
}, /*#__PURE__*/React$1.createElement("path", {
  d: "M29.5 0C45.792 0 59 13.208 59 29.5S45.792 59 29.5 59 0 45.792 0 29.5 13.208 0 29.5 0zm0 2C14.312 2 2 14.312 2 29.5S14.312 57 29.5 57 57 44.688 57 29.5 44.688 2 29.5 2zM23 22l16 8-16 8V22zm2 3.235v9.529L34.529 30 25 25.235z"
}));

export default Play;
